/* eslint-disable global-require */
export default [
    {
        hasNativeSupport: () => typeof Array.from === 'function' && Array.prototype.includes === 'function',
        polyfill(resolve) {
            require.ensure([], () => {
                resolve(require('./array-esnext'));
            });
        },
    },
    {
        hasNativeSupport: () => typeof Object.assign === 'function',
        polyfill(resolve) {
            require.ensure([], () => {
                Object.defineProperty(Object, 'assign', {
                    enumerable: false,
                    configurable: true,
                    writable: true,
                    value: require('object.assign'),
                });
                resolve();
            });
        },
    },
    {
        hasNativeSupport: () => typeof Object.entries === 'function',
        polyfill(resolve) {
            require.ensure([], () => {
                require('object.entries').shim();
                resolve();
            });
        },
    },
    {
        hasNativeSupport: () => !!window.URLSearchParams && (new window.URLSearchParams({ a: 1 })).toString() === 'a=1',
        polyfill(resolve) {
            require.ensure([], () => {
                window.URLSearchParams = require('url-search-params');
                resolve();
            });
        },
    },
    {
        hasNativeSupport: () => !!require('es6-set/is-native-implemented'),
        polyfill(resolve) {
            require.ensure([], () => {
                window.Set = require('es6-set/polyfill');
                resolve();
            });
        },
    },
];



// WEBPACK FOOTER //
// ./sib-website/assets/src/js/app/util/polyfills/polyfill-registry.js